import { Button } from '@chakra-ui/react';
import type { ButtonProps } from '@chakra-ui/react';

const ButtonRed = ({ children, onClick, ...props }: ButtonProps) => {
  return (
    <Button
      variant="subtle"
      color={props.variant === 'outline' ? 'red.100' : 'white'}
      bg={props.variant === 'outline' ? 'bg' : 'red.100'}
      borderColor={props.variant === 'outline' ? 'red.100' : 'bg'}
      borderRadius="xl"
      onClick={onClick}
      {...props}
    >
      {children}
    </Button>
  );
};

const MemoizedButtonRed = memo(ButtonRed);
export { MemoizedButtonRed as ButtonRed };
